class RokiHeader extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-menu-toggle]');
      if (!trigger) return;
      const open = this.classList.toggle('is-menu-open');
      trigger.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('no-scroll', open);
    });
  }
}

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('[name="add"]');
    if (!this.form) return;
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  async onSubmit(event) {
    event.preventDefault();
    if (this.button) {
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
    }
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(this.form)
      });
      if (!response.ok) throw new Error('Cart request failed');
      await response.json();
      const html = await fetch(`${window.Shopify.routes.root}?section_id=header`).then((value) => value.text());
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const freshHeader = documentFragment.querySelector('roki-header');
      const currentHeader = document.querySelector('roki-header');
      if (freshHeader && currentHeader) currentHeader.replaceWith(freshHeader);
      requestAnimationFrame(() => document.querySelector('[data-cart-drawer]')?.showModal());
    } catch (error) {
      const status = this.querySelector('[data-product-status]');
      if (status) status.textContent = status.dataset.errorText;
    } finally {
      if (this.button) {
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    }
  }
}

class ProductInfo extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-variant-select]');
    if (!this.select) return;
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.select.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange() {
    const variant = this.variants.find((item) => String(item.id) === this.select.value);
    if (!variant) return;
    const input = this.querySelector('[name="id"]');
    const button = this.querySelector('[name="add"]');
    if (input) input.value = variant.id;
    if (button) {
      button.disabled = !variant.available;
      button.querySelector('span').textContent = variant.available ? button.dataset.addText : button.dataset.soldText;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }
}

class MediaGallery extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-media-target]');
      if (!button) return;
      this.querySelectorAll('[data-media]').forEach((media) => media.hidden = media.id !== button.dataset.mediaTarget);
      this.querySelectorAll('[data-media-target]').forEach((item) => item.setAttribute('aria-current', String(item === button)));
    });
  }
}

document.addEventListener('click', (event) => {
  const open = event.target.closest('[data-cart-open]');
  const close = event.target.closest('[data-cart-close]');
  const sticky = event.target.closest('[data-sticky-submit]');
  const dialog = document.querySelector('[data-cart-drawer]');
  if (open && dialog) dialog.showModal();
  if (close && dialog) dialog.close();
  if (sticky) document.getElementById(sticky.dataset.stickySubmit)?.requestSubmit();
});

document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('video[data-autoplay]').forEach((video) => video.play().catch(() => {}));
});

customElements.define('roki-header', RokiHeader);
customElements.define('product-form', ProductForm);
customElements.define('product-info', ProductInfo);
customElements.define('media-gallery', MediaGallery);
